import { InvokeApi } from "../../Utils/InvokeApi";

export const CreateChapterContent = async (data) => {
  const requestObj = {
    path: `/content/create`,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    postData: data,
  };
  return InvokeApi(requestObj);
};

export const UpdateChapterContent = async (contentId, data) => {
    const requestObj = {
      path: `/content/${contentId}`,
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      postData: data,
    };
    return InvokeApi(requestObj);
  };
  

export const GetChapterContents = async (data) => {
  
  const { page, limit, chapterId, filters } = data;
 
  const params = new URLSearchParams();
  if (data !== false) {
    params.set('page', page.toString());
    params.set('limit', limit.toString());
    if(chapterId) params.set('chapterId', chapterId);
  // Only include key and value if both are provided
  if (filters && typeof filters === 'object') {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== '') {
          params.set(key, value);
        }
      });
    }
  // if (key && value) {
  //   params.set('key', key);
  //   params.set('value', value);
  // }
}
  let paramQuery = data !== false ? params.toString() : ""
  const requestObj = {
    path: `/content?${paramQuery}`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
      "Content-Type": "application/json",
    },
  };
  return InvokeApi(requestObj);
};

export const DeleteChapterContent = async (contentId) => {
    const requestObj = {
      path: `/content/${contentId}`,
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
        "Content-Type": "application/json",
      },
    };
    return InvokeApi(requestObj);
};

